import { View, Text, TouchableOpacity } from "react-native";
import React from "react";
import MyText from "../../custom/MyText";
import {
  chatMeSenderBackground,
  chatNotMeSenderBackground,
  shadowSm,
} from "../../../colors";
import MessageStatus from "./MessageStatus";
import { useNavigation } from "@react-navigation/native";
import { width } from "../../../imports";
import { Image } from "react-native";
import { useSelector } from "react-redux";

export default function TutorialMessage(props) {
 
  const main = useSelector((store) => store.main);
  const { meSender, value, status, sender, uri } = props;
  const navigation = useNavigation();
  return (
    <View
      style={{
        alignItems: meSender ? "flex-start" : "flex-end",
        marginVertical: 10,
      }}
    >
      <TouchableOpacity
        onPress={() => navigation.navigate("Tutorial", { id: uri.id })}
        style={{
          width: width / 2.3,
          height: width / 1.5,
          margin: 10,
          ...shadowSm,
          padding: 10,
          alignItems: "center",
          borderRadius: 15,
        }}
      >
        <View>
          <Image
            source={{ uri: uri.picURl }}
            style={{ width: width / 2.6, height: width / 2.6 }}
            resizeMode="contain"
          />
        </View>
        <View style={{ flex: 1 }}></View>
        <MyText style={{ marginTop: 5, fontSize: 11 }}>
          {main.rtl ? uri.titleFa : titleEn}
        </MyText>
        {/* <View style={{ flexDirection: "row", alignItems: "center" }}>
          <View style={{ flex: 1 }}></View>

          <View style={{ marginHorizontal: 1 }}>
            <HeartIcon />
          </View>
          <MyText
            style={{ marginHorizontal: 4, fontSize: 10 }}
          >{`${likes}`}</MyText>
        </View> */}
      </TouchableOpacity>
      <View
        style={{
          flexDirection: meSender ? "row" : "row-reverse",
          width: "65%",
        }}
      >
        <View style={{ flex: 1 }}></View>
        <MessageStatus meSender={sender === "doctor"} status={status} />
      </View>
    </View>
  );
}
